export default __webpack_public_path__ + "assets/audio/1-50494839_clip.mp3";